export default __webpack_public_path__ + "static/media/star7.8724f99d.mp3";